/**
 * GA4 recommended events that require ecommerce data clearing
 * Based on Google's official documentation
 */
export const GA4_ECOMMERCE_EVENTS = [
  // E-commerce events
  'add_payment_info',
  'add_shipping_info',
  'add_to_cart',
  'add_to_wishlist',
  'begin_checkout',
  'purchase',
  'refund',
  'remove_from_cart',
  'select_item',
  'select_promotion',
  'view_cart',
  'view_item',
  'view_item_list',
  'view_promotion'
] as const

/**
 * All GA4 recommended events (including non-ecommerce)
 * Based on Google's official documentation from the screenshot
 */
export const GA4_RECOMMENDED_EVENTS = [
  'add_payment_info',
  'add_shipping_info',
  'add_to_cart',
  'add_to_wishlist',
  'begin_checkout',
  'close_convert_lead',
  'close_unconvert_lead',
  'disqualify_lead',
  'earn_virtual_currency',
  'generate_lead',
  'join_group',
  'level_end',
  'level_start',
  'level_up',
  'login',
  'post_score',
  'purchase',
  'qualify_lead',
  'refund',
  'remove_from_cart',
  'search',
  'select_content',
  'select_item',
  'select_promotion',
  'share',
  'sign_up',
  'spend_virtual_currency',
  'tutorial_begin',
  'tutorial_complete',
  'unlock_achievement',
  'view_cart',
  'view_item',
  'view_item_list',
  'view_promotion',
  'working_lead'
] as const

export type GA4EcommerceEvent = (typeof GA4_ECOMMERCE_EVENTS)[number]
export type GA4RecommendedEvent = (typeof GA4_RECOMMENDED_EVENTS)[number]
